import React, { useState, useEffect } from "react";
import { Layout, Input, Button, Collapse, Tag, InputNumber } from "antd";
import "./index.scss";
import axiosInstance from "@/axios/axiosInstance";
import _ from "lodash"; // 引入lodash来使用_.debounce

const { Header, Content, Footer } = Layout;

const DataGallery = () => {
  // 控制展开/收起状态，使用面板的key作为activeKey
  const [activeKey, setActiveKey] = useState([]);
  const [dataSet, setData] = useState([]);
  const [selectedTag, setSelectedTag] = useState("");
  const [priceRange, setPriceRange] = useState({
    minPrice: null,
    maxPrice: null,
  });
  const getData = async (a) => {
    let param = "";
    if (selectedTag) {
      // 如果 selectedTag 不为空，则添加 serviceType 参数
      param = `serviceType=${selectedTag}&`;
    }
    param += `title=${""}`;
    try {
      const response = await axiosInstance.get(
        `serviceManager/page/list?${param}`
      );
      let compute = response.data.data;
      setData(compute);
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };
  useEffect(() => {
    getData();
    document.title =
      "渐风AI,AI开发服务,AI数据标注服务,AI数据清洗服务,大模型开发,大模型调优,LLM定制化,大模型蒸馏,AI技术服务在线交易";
  }, [selectedTag]); // 空依赖项数组表示这个 effect 只在组件挂载时运行
  // 处理价格区间的变化
  const handlePriceChange = (type, value) => {
    setPriceRange((prevState) => ({
      ...prevState,
      [type]: value,
    }));
  };

  // 搜索函数（这里只是打印了价格区间，实际中可能是发送请求）
  const search = () => {
    if (priceRange.minPrice !== null && priceRange.maxPrice !== null) {
      console.log(
        `搜索价格区间: ${priceRange.minPrice} 到 ${priceRange.maxPrice}`
      );
      // 在这里发送搜索请求或执行其他操作
    } else {
      console.log("请输入完整的价格区间！");
    }
  };
  const handleTagClick = (tag) => {
    setSelectedTag(tag.key);
  };

  const fileOptions = [
    { key: "", value: "全部" },
    { key: "1", value: "AI规划咨询" },
    { key: "2", value: "AI系统方案设计 " },
    { key: "3", value: "AI数据处理" },
    { key: "4", value: "AI模型训练" },
    { key: "5", value: "AI产品开发" },
    { key: "6", value: "AI模型部署" },
    { key: "11", value: "AI聊天" },
    { key: "22", value: "AI绘画 " },
    { key: "33", value: "AI视频" },
    { key: "44", value: "AI语言处理" },
    { key: "55", value: "AI办公效率提升" },
    { key: "66", value: "AI审计风控" },
  ].map((tag) => (
    <Tag
      color={selectedTag === tag.key ? "blue" : "default"}
      key={tag.key}
      onClick={() => handleTagClick(tag)}
    >
      {tag.value}
    </Tag>
  ));

  const getLabel = (l) => {
    const bq = [
      { key: "1", value: "AI规划咨询" },
      { key: "2", value: "AI系统方案设计 " },
      { key: "3", value: "AI数据处理" },
      { key: "4", value: "AI模型训练" },
      { key: "5", value: "AI产品开发" },
      { key: "6", value: "AI模型部署" },
      { key: "11", value: "AI聊天" },
      { key: "22", value: "AI绘画 " },
      { key: "33", value: "AI视频" },
      { key: "44", value: "AI语言处理" },
      { key: "55", value: "AI办公效率提升" },
      { key: "66", value: "AI审计风控" },
    ];
    let label = bq.find((v) => v.key == l).value;
    return label;
  };
  const debouncedFetchData = _.debounce(getData, 1000);
  const handleChange = (e) => {
    debouncedFetchData(e.target.value);
  };

  const toDetail = (record) => {
    // 构建 URL 参数
    const params = new URLSearchParams({
      id: record.serviceManagerId,
      profilePictureUrl: record.profilePictureUrl,
      nickName: record.nickName,
    });
    const url = `/service_detail?${params.toString()}`;
    window.open(url, "_blank"); // 在新窗口或新标签页中打开
  };
  return (
    <div>
      <Layout className="suanlist">
        <Header className="suanlist-hea">
          <div className="name">服务交易</div>
          <Input
            placeholder="搜索"
            style={{ width: "300px", marginTop: "16px" }}
            onChange={handleChange}
            allowClear
          />
        </Header>
        <Content className="suan-cont">
          <Collapse activeKey={activeKey} onChange={setActiveKey}>
            <div className="collapse-panel">
              <div className="collapse-content">
                <div className="cont-shai">
                  <div className="name">服务类型</div>
                  <div direction="vertical" className="chuzsz">
                    {fileOptions}
                  </div>{" "}
                </div>
              </div>
            </div>
          </Collapse>
        </Content>
        <div className="soujg">
          <div>默认排序</div>
          <div className="pice">
            价格：
            <InputNumber
              placeholder="请输入最低价格"
              min={0} // 根据需要设置最小值
              value={priceRange.minPrice}
              onChange={(value) => handlePriceChange("minPrice", value)}
            />
            -
            <InputNumber
              placeholder="请输入最高价格"
              min={0} // 根据需要设置最小值
              value={priceRange.maxPrice}
              onChange={(value) => handlePriceChange("maxPrice", value)}
            />
            <Button type="primary" onClick={search}>
              搜索
            </Button>{" "}
          </div>
        </div>
        <Footer>
          {dataSet.map((v, index) => {
            return (
              <div className="cont-san" key={v.id}>
                <div className="cont-l">
                  <div className="title" onClick={() => toDetail(v)}>
                    {v.title}{" "}
                  </div>
                  <div>
                    {/*<span className='xinx'>{v.introduction} </span>*/}
                  </div>
                </div>
                <div className="cont-r">
                  <div>
                    <span className="xinx">{getLabel(v.serviceType)}</span>
                    <span className="xinx fileUnit">
                      {v.servicePrincipal}
                      {v.fileUnit}
                    </span>
                  </div>
                  <div>
                    <div className="mone">￥ {v.paymentPrice} 元</div>
                    <div className="leng" onClick={() => toDetail(v)}>
                      了解更多
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </Footer>
      </Layout>
    </div>
  );
};

export default DataGallery;
